"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectFieldUiSchema = void 0;
const json_schema_keys_1 = require("../../json_schema_keys");
const field_ui_schema_1 = require("./field_ui_schema");
class ObjectFieldUiSchema extends field_ui_schema_1.FieldUiSchema {
    constructor(objectField) {
        super();
        this[json_schema_keys_1.JsonSchemaKeys.UI_ORDER_KEY] = objectField.fields.map((f) => f.uniqueKey());
        for (const field of objectField.fields) {
            const schema = field.uiSchema();
            if (!(schema instanceof field_ui_schema_1.EmptyUiSchema)) {
                this[field.uniqueKey()] = field.uiSchema();
            }
        }
    }
}
exports.ObjectFieldUiSchema = ObjectFieldUiSchema;
